import { useEffect, useState, useRef } from 'react'
import { toast } from 'react-hot-toast'
import { ButtonFilledAutoWidth, ButtonOutlinedAutoWidth } from '../../components/button'
import { TextAreaInput1, TextInput } from '../../components/input'
import { useNavigate, useLocation } from 'react-router-dom'
import GoBack from '../../components/back/GoBack'
import ErrorComponent from '../../components/ErrorComponent'
import { Select } from 'antd'
import { batch, useSelector } from 'react-redux'
import { UpdateClassBookingService, UpdatePersonalTrainingSubscriptionTeacherService } from '../../services/class_booking/classBookingServices'
import OfflineCustomerMenu from './InvoiceMenu'
import { CreateClientService,UpdateClientService } from '../../services/ClientServices'
import { GetClassRoomService } from '../../services/admin/ClassRoomServices'
import {BiCheckbox,BiCheckboxSquare} from 'react-icons/bi'
import { UploadUserFile } from '../../services/AuthServices'
import Uploader from '../../components/Uploader';
import logo from '../../../folder/images/app_logo.png'
import html2canvas from 'html2canvas'
import '@fontsource/poppins/400.css'
import '@fontsource/poppins/600.css'
import '@fontsource/poppins/700.css'
import '@fontsource/bebas-neue/400.css'
import '@fontsource/dancing-script/700.css'
import { FiBookOpen, FiGlobe, FiMapPin, FiPhone, FiTarget, FiTrendingUp } from 'react-icons/fi'
import { AiOutlineClose } from 'react-icons/ai'
import { CreateInvoiceService, UpdateInvoiceService } from '../../services/admin/InvoiceServices'
import moment from 'moment'
import InvoiceMenu from './InvoiceMenu'
import { getGstBreakup, sumGstBreakup, amountInWords, DEFAULT_SAC_CODE, COMPANY_GSTIN, PLACE_OF_SUPPLY, SUPPLY_TYPE, RECIPIENT_GSTIN } from '../../helpers/gstHelpers'

function OfflineCustomerCE() {

  const roles = useSelector(state=>state.Auth.roles)
  const {state} = useLocation()
  
  const [data, setdata] = useState({});
  const [feeBillItems, setfeeBillItems] = useState([{ id: Date.now(), line_item: '', duration: '', price: '' }]);
  const [feeBillMeta, setfeeBillMeta] = useState({ payment_date: '' });

  const [captureImageSrc, setcaptureImageSrc] = useState('')
  const [signatureImageSrc, setsignatureImageSrc] = useState('')
  const signatureImageUrl = 'https://myleadsconsolebucket.s3.ap-south-1.amazonaws.com/public/uploads/fees_report.png'
  const [paymentMode, setpaymentMode] = useState('Cash')
  const [signatureText] = useState(() => {
   const signatures = ['My Academy Partner']
    return signatures[Math.floor(Math.random() * signatures.length)]
  })
  const posterRef = useRef(null)
  const receiptRef = useRef(null)

  const [invoiceData,setinvoiceData] = useState({invoice_number:'',payment_date:'',fee_details:[],total_amount:0})


  // const in

  
  const navigate = useNavigate();

  useEffect(() => {
    if (state?._id !== null && state?._id !== undefined) {

      let d = state 

      let passData = {
        ...d,
        class_room:{label:d?.customer?.class_room?.label,value:d?.customer?.class_room?._id},
        fees_end_date:d?.fees_end_date ? d?.fees_end_date?.split('T')[0] : '',
      }

      setinvoiceData({...invoiceData,invoice_number: state?.invoice_number,payment_date: state?.payment_date,fee_details: state?.fee_details,total_amount: state?.total_amount,payment_mode: state?.payment_mode})
      setdata(state?.customer)
      setfeeBillMeta({payment_date: state?.payment_date?.split('T')[0]})
      setfeeBillItems(state?.fee_details?.length > 0 ? state?.fee_details?.map((item) => ({ id: Date.now() + Math.random(), line_item: item.line_item, duration: item.duration, price: item.price })) : [{ id: Date.now(), line_item: '', duration: '', price: '' }])
      setpaymentMode(state?.payment_mode || 'Cash')
    
    }

  }, [state])

  useEffect(() => {
    let active = true

    async function loadCaptureImage() {
      if (!data?.photo) {
        setcaptureImageSrc('')
        return
      }

      const remoteUrl = `${process.env.REACT_APP_AWS_IMAGE_URL}${data.photo}`
      try {
        const response = await fetch(remoteUrl, { mode: 'cors' })
        const blob = await response.blob()
        const reader = new FileReader()
        reader.onloadend = () => {
          if (active) {
            setcaptureImageSrc(reader.result || remoteUrl)
          }
        }
        reader.readAsDataURL(blob)
      } catch (error) {
        if (active) {
          setcaptureImageSrc(remoteUrl)
        }
      }
    }

    loadCaptureImage()

    return () => {
      active = false
    }
  }, [data?.photo])

  useEffect(() => {
    let active = true

    async function loadSignatureImage() {
      try {
        const response = await fetch(signatureImageUrl, { mode: 'cors' })
        const blob = await response.blob()
        const reader = new FileReader()
        reader.onloadend = () => {
          if (active) {
            setsignatureImageSrc(reader.result || signatureImageUrl)
          }
        }
        reader.readAsDataURL(blob)
      } catch (error) {
        if (active) {
          setsignatureImageSrc(signatureImageUrl)
        }
      }
    }

    loadSignatureImage()

    return () => {
      active = false
    }
  }, [signatureImageUrl])



  function handleFeeBillChange(e) {
    const { name, value } = e.target
    setfeeBillMeta({ ...feeBillMeta, [name]: value })
  }

  function handleFeeItemChange(index, field, value) {
    setfeeBillItems((currentItems) => currentItems.map((item, itemIndex) => {
      if (itemIndex !== index) {
        return item
      }

      return { ...item, [field]: value }
    }))
  }

  function addFeeItem() {
    setfeeBillItems((currentItems) => ([
      ...currentItems,
      { id: Date.now(), line_item: '', duration: '', price: '' }
    ]))
  }

  function removeFeeItem(index) {
    setfeeBillItems((currentItems) => currentItems.length === 1 ? currentItems : currentItems.filter((_, itemIndex) => itemIndex !== index))
  }

  async function handleDownloadCard(ref, fileName) {
    if (!ref?.current) {
      toast.error('Template is not ready for download')
      return
    }

    const canvas = await html2canvas(ref.current, {
      scale: 2,
      useCORS: true,
      backgroundColor: '#ffffff'
    })

    const url = canvas.toDataURL('image/png')
    const link = document.createElement('a')
    link.href = url
    link.download = `${fileName}.png`
    link.click()
  }

  const parseAmount = (value) => {
    const amountValue = Number(value || 0)
    return Number.isNaN(amountValue) ? 0 : amountValue
  }

  const feeBillTotal = feeBillItems.reduce((total, item) => total + parseAmount(item?.price), 0)
  const studentImage = data?.photo ? `${process.env.REACT_APP_AWS_IMAGE_URL}${data?.photo}` : ''
  const displayImage = captureImageSrc || studentImage
  const amountText = (value) => parseAmount(value).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  // Always derive the preview from the live form fields so it never drifts from what's currently typed
  const invoiceFeeItems = feeBillItems
  const gstTotals = sumGstBreakup(invoiceFeeItems)
  const invoiceGrandTotal = feeBillTotal
  const invoiceSeed = String(state?._id || data?.mobile || '001').replace(/[^a-zA-Z0-9]/g, '').slice(-4).toUpperCase() || '001'
  // const invoiceNo = `MyAcademy/2026/${invoiceSeed}`
  const receiptNo = String(feeBillItems.length).padStart(4, '0')



  async function generateInvoice(){
     if(feeBillItems?.length === 0){ 
       toast.error('Please add at least one fee item to generate invoice')
       return
     }
     
     if(!feeBillMeta?.payment_date){
       toast.error('Please select a payment date')
       return
     }
     
     const hasValidItems = feeBillItems.every(item => item.line_item && item.price)
     if(!hasValidItems){
       toast.error('All fee items must have particulars and amount')
       return
     }
     
     try {
       const loadingToast = toast.loading('Updating invoice...')
       const response = await UpdateInvoiceService({customer:data?._id,payment_date:feeBillMeta?.payment_date,fee_details:feeBillItems,total_amount:feeBillTotal,payment_mode:paymentMode},state?._id)
       
       toast.dismiss(loadingToast)
       
       if(response?.status === 200){
        setinvoiceData(response?.data?.datas)
        toast.success('Invoice updated successfully!')
       }else{
        toast.error(response?.data?.message || 'Something went wrong while updating invoice')
       }
     } catch (error) {
       console.error('Error updating invoice:', error)
       toast.error('Failed to update invoice. Please try again.')
     }
  }

  function handleResetForm() {
    setfeeBillItems([{ id: Date.now(), line_item: '', duration: '', price: '' }])
    setfeeBillMeta({ payment_date: '' })
    setinvoiceData({invoiceNo:'',payment_date:'',fee_details:[],total_amount:0})
    toast.success('Form reset successfully!')
  }

  function handleExitAndDownload() {
    navigate(-1)
  }
 
  return (
    <div className='md:flex w-full md:max-h-screen min-h-[100vh]'>

   
     
      <div>
      <InvoiceMenu />
      </div> 
      <div className='px-5 mb-5 bg-slate-100 w-full h-full'>


          <GoBack />

          <div>
            <h6 className='text-[15px] font-[600] mb-1'>Fees Bill Generation is in progress...</h6>
            <h6 className='text-[11px] font-[400]'>Fill the below arguments and click download to generate the fees receipt.</h6>


            <div className='mb-4 grid md:grid-cols-3 gap-3'>
              <TextInput
                mandatory={true}
                label={'Payment Date'}
                variant="standard"
                name="payment_date"
                type="date" 
                value={feeBillMeta.payment_date}
                handlechange={handleFeeBillChange}
                placeholder=""
              />
            </div>

            <div className='mb-4 flex justify-between items-center gap-3'>
              <h6 className='text-[11px] font-[500] text-slate-700'>Add multiple fee line items, duration text, and price before downloading.</h6>
              <ButtonOutlinedAutoWidth btnName={'Add Line Item'} onClick={addFeeItem} />
            </div>

            <div className='space-y-3 mb-4 bg-white border border-slate-200 rounded-lg p-3'>
              {feeBillItems.map((item, index) => (
                <div key={item.id} className='grid grid-cols-1 md:grid-cols-4 gap-3 items-end'>
                  <TextInput
                    mandatory={false}
                    label={'Particulars'}
                    variant="standard"
                    name={`line_item_${index}`}
                    type="text"
                    value={item.line_item}
                    handlechange={(event) => handleFeeItemChange(index, 'line_item', event.target.value)}
                    placeholder=""
                  />

                  <TextInput
                    mandatory={false}
                    label={'Duration'}
                    variant="standard"
                    name={`duration_${index}`}
                    type="text"
                    value={item.duration}
                    handlechange={(event) => handleFeeItemChange(index, 'duration', event.target.value)}
                    placeholder=""
                  />

                  <TextInput
                    mandatory={false}
                    label={'Amount'}
                    variant="standard"
                    name={`price_${index}`}
                    type="number"
                    value={item.price}
                    handlechange={(event) => handleFeeItemChange(index, 'price', event.target.value)}
                    placeholder=""
                  />

                  <div className='flex justify-end'>
                    <ButtonOutlinedAutoWidth btnName={feeBillItems.length > 1 ? 'Remove' : 'Item'} onClick={() => removeFeeItem(index)} />
                  </div>
                </div>
              ))}
              <div>
                <h6 className='text-[11px] font-[500] text-slate-700 mb-2'>Payment Mode</h6>
                <Select
                  value={paymentMode}
                  bordered={false}
                  placeholder="Select payment mode"
                  onChange={(value) => setpaymentMode(value)}
                  options={['Cash', 'Online'].map((mode) => ({ label: mode, value: mode }))}
                  className='w-full border outline-0 focus:outline-0 bg-white focus:ring-0 focus:border-none focus:border-transparent focus:ring-offset-0 focus:shadow-none'
                />
              </div>
            </div>

            <div className='mb-4 flex gap-2'>
              <ButtonOutlinedAutoWidth btnName={'Update Invoice'} onClick={() => generateInvoice()} />
              {invoiceData?.invoice_number &&
              <ButtonFilledAutoWidth btnName={'Download Fees Bill'} onClick={() => handleDownloadCard(receiptRef, 'offline-student-fee-receipt')} />}
              <ButtonOutlinedAutoWidth btnName={'Reset'} onClick={() => handleResetForm()} />
              <ButtonOutlinedAutoWidth btnName={'Exit'} onClick={() => handleExitAndDownload()} />
            </div>

            <div className='overflow-x-auto pb-4'>
              <div ref={receiptRef} className='w-[880px] bg-white border border-slate-300 overflow-hidden' style={{ fontFamily: 'Poppins, sans-serif' }}>
                <div className='h-[14px] bg-[#072A67] relative'>
                  <div className='absolute -bottom-[2px] left-0 w-[170px] h-[22px] bg-[#e5aa1f] rounded-r-full' />
                </div>

                <div className='px-7 py-5 border-b border-slate-200'>
                  <div className='flex justify-between items-start gap-6'>
                    <div className='w-[40%]'>
                      <img src={logo} alt="appLogo" className="h-20 object-contain mb-1" />
                      <h4 className='text-[18px] leading-5 text-[#072A67] font-[700]'>My Academy Partner</h4>
                      <h4 className='text-[12px] mt-1 text-slate-700'>Smart Learning. Strong Concepts. Bright Future.</h4>
                    </div>
                    <div className='text-left border-l border-slate-300 pl-6 w-[60%]'>
                      <h2 className='text-[50px] text-[#072A67] leading-[30px]' style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.03em' }}>MY ACADEMY PARTNER</h2>
                      <h4 className='text-[40px] leading-[26px] mt-2 text-[#e5aa1f]' style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.08em' }}>KUNDAPURA</h4>
                      <div className='mt-5 text-[15px] text-slate-700 leading-6'>
                        <h4 className='flex items-center'><FiMapPin className='mr-2 mt-1 text-[#072A67]' />Near New Bus Stand, Kundapura</h4>
                        <h4 className='pl-7'>Udupi Dist., Karnataka - 576201</h4>
                        <h4 className='flex items-center mt-1'><FiPhone className='mr-2 text-[#072A67]' />96865 83960</h4>
                        <h4 className='flex items-center mt-1'><FiGlobe className='mr-2 text-[#072A67]' />www.myacademypartner.com</h4>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='px-7 relative bg-[#072A67] w-[95%] mx-auto my-4 rounded-[40px]  h-[50px] py-3'>
                  <div className='text-white text-center  py-2 rounded-[20px] text-[25px] -mt-[16px]' style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.03em' }}>TAX INVOICE / FEE RECEIPT</div>
                </div>

                <div className='px-7 pb-4'>
                  <div className='grid grid-cols-2 gap-3 text-[15px] border border-slate-300 rounded-md p-4 bg-slate-50'>
                    <h5><span className='font-[700] text-[#072A67]'>INVOICE NO</span> : {invoiceData?.invoice_number || '-'}</h5>
                    <h5><span className='font-[700] text-[#072A67]'>GSTIN</span> : {COMPANY_GSTIN}</h5>
                    <h5><span className='font-[700] text-[#072A67]'>DATE</span> : {moment(invoiceData?.createdAt)?.format('LLL') || '-'}</h5>
                    <h5><span className='font-[700] text-[#072A67]'>ACADEMIC YEAR</span> : 2026-27</h5>
                  </div>
                </div>

                <div className='px-7 pb-3'>
                  <h4 className='text-[24px] leading-7 text-[#072A67] mb-2' style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.02em' }}>STUDENT DETAILS</h4>
                  <div className='border border-slate-300 rounded-md p-4 grid grid-cols-2 gap-x-8 gap-y-3 text-[15px]'>
                    <h5><span className='font-[700] text-[#072A67]'>STUDENT NAME</span> : {data?.name || '-'}</h5>
                    <h5><span className='font-[700] text-[#072A67]'>STUDENT ID</span> : {data?.studentId || '-'}</h5>
                    <h5><span className='font-[700] text-[#072A67]'>CLASS</span> : {data?.standard?.label || '-'}</h5>
                    <h5><span className='font-[700] text-[#072A67]'>RECIPIENT GSTIN</span> : {RECIPIENT_GSTIN}</h5>
                  </div>
                </div>

                <div className='px-7 pb-3'>
                  <h4 className='text-[24px] leading-7 text-[#072A67] mb-2' style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.02em' }}>GST / SUPPLY DETAILS</h4>
                  <div className='border border-slate-300 rounded-md p-4 grid grid-cols-2 gap-x-8 gap-y-3 text-[15px]'>
                    <h5><span className='font-[700] text-[#072A67]'>PLACE OF SUPPLY</span> : {PLACE_OF_SUPPLY}</h5>
                    <h5><span className='font-[700] text-[#072A67]'>SUPPLY TYPE</span> : {SUPPLY_TYPE}</h5>
                    <h5><span className='font-[700] text-[#072A67]'>REVERSE CHARGE</span> : No</h5>
                    <h5><span className='font-[700] text-[#072A67]'>TAX INCLUSIVE</span> : Yes - Rs. {amountText(invoiceGrandTotal)} is inclusive of GST</h5>
                  </div>
                </div>

                <div className='px-7 pb-3'>
                  <h4 className='text-[24px] leading-7 text-[#072A67] mb-2' style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.02em' }}>FEE DETAILS</h4>
                  <div className='border border-slate-300 rounded-md overflow-hidden'>
                    <table className='w-full border-collapse text-[13px]' style={{ tableLayout: 'auto' }}>
                      <thead>
                        <tr className='bg-[#072A67] text-white font-[700]'>
                          <th className='p-3 text-center whitespace-nowrap'>#</th>
                          <th className='p-3 text-left border-l border-white/20'>PARTICULARS</th>
                          <th className='p-3 text-center border-l border-white/20 whitespace-nowrap'>SAC</th>
                          <th className='p-3 text-center border-l border-white/20 whitespace-nowrap'>DURATION</th>
                          <th className='p-3 text-right border-l border-white/20 whitespace-nowrap'>TAXABLE VALUE</th>
                          <th className='p-3 text-center border-l border-white/20 whitespace-nowrap'>CGST</th>
                          <th className='p-3 text-center border-l border-white/20 whitespace-nowrap'>SGST</th>
                          <th className='p-3 text-right border-l border-white/20 whitespace-nowrap'>TOTAL</th>
                        </tr>
                      </thead>
                      <tbody>
                        {invoiceFeeItems.map((item, index) => {
                          const { taxable, cgst, sgst, total } = getGstBreakup(item?.price)
                          return (
                            <tr key={item?.id || index} className='border-t border-slate-200'>
                              <td className='p-3 text-center'>{index + 1}</td>
                              <td className='p-3 border-l border-slate-200'>{item?.line_item || '-'}</td>
                              <td className='p-3 border-l border-slate-200 text-center whitespace-nowrap'>{item?.sac || DEFAULT_SAC_CODE}</td>
                              <td className='p-3 border-l border-slate-200 text-center whitespace-nowrap'>{item?.duration || feeBillMeta?.joining_date || '-'}</td>
                              <td className='p-3 border-l border-slate-200 text-right whitespace-nowrap'>₹ {amountText(taxable)}</td>
                              <td className='p-3 border-l border-slate-200 text-center whitespace-nowrap'>
                                <div>9%</div>
                                <div>₹ {amountText(cgst)}</div>
                              </td>
                              <td className='p-3 border-l border-slate-200 text-center whitespace-nowrap'>
                                <div>9%</div>
                                <div>₹ {amountText(sgst)}</div>
                              </td>
                              <td className='p-3 border-l border-slate-200 text-right font-[700] whitespace-nowrap'>₹ {amountText(total)}</td>
                            </tr>
                          )
                        })}
                      </tbody>
                      <tfoot>
                        <tr className='bg-[#072A67] text-white font-[700] border-t border-slate-200'>
                          <td className='p-3 text-right' colSpan={5}>TOTAL</td>
                          <td className='p-3 border-l border-white/20 text-center whitespace-nowrap'>₹ {amountText(gstTotals.cgst)}</td>
                          <td className='p-3 border-l border-white/20 text-center whitespace-nowrap'>₹ {amountText(gstTotals.sgst)}</td>
                          <td className='p-3 border-l border-white/20 text-right whitespace-nowrap'>₹ {amountText(gstTotals.total)}</td>
                        </tr>
                        <tr className='border-t border-slate-200'>
                          <td className='p-3 text-right font-[700] bg-[#072A67] text-white' colSpan={7}>FINAL AMOUNT PAID</td>
                          <td className='p-3 border-l border-slate-200 text-right text-[#072A67] font-[800] bg-[#f2c14e] whitespace-nowrap'>₹ {amountText(invoiceGrandTotal)}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>

                <div className='px-7 pb-3'>
                  <div className='border border-slate-300 rounded-md p-3 flex justify-between items-center gap-4 bg-slate-50 text-[13px]'>
                    <h5><span className='font-[700] text-[#072A67]'>Amount in Words:</span> {amountInWords(invoiceGrandTotal)}</h5>
                    <h5 className='text-slate-500 text-[11px] whitespace-nowrap'>Taxable Value + CGST + SGST = Total Invoice Value</h5>
                  </div>
                </div>

                <div className='px-7 pb-3'>
                  <h4 className='text-[25px] leading-7 text-[#072A67] mb-2' style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '0.02em' }}>PAYMENT DETAILS</h4>
                  <div className='border border-slate-300 rounded-md p-3 grid grid-cols-3 text-[13.5px]'>
                    <h5><span className='font-[700] text-[#072A67]'>PAYMENT METHOD</span><br />{invoiceData?.payment_mode || '-'}</h5>
                    <h5><span className='font-[700] text-[#072A67]'>PAYMENT DATE</span><br />{moment(invoiceData?.payment_date)?.format('ll') || '-'}</h5>
                    <h5><span className='font-[700] text-[#072A67]'>PAYMENT STATUS</span><br /><span className='bg-green-100 text-green-700 px-2 rounded-full text-[12px] font-[700]'>PAID</span></h5>
                  </div>
                </div>

                <div className='px-7 pb-6 grid grid-cols-2 gap-4'>
                  <div className='border border-slate-300 rounded-md p-3 text-[13px]'>
                    <h5 className='font-[700] text-[#072A67] mb-1'>IMPORTANT NOTES</h5>
                    <h5>- Fees once paid are non-refundable.</h5>
                    <h5>- Keep this tax invoice/receipt for future reference.</h5>
                  </div>
                  <div className='flex flex-col justify-end min-h-[92px]'>
                    <div className='w-full flex justify-end'>
                      <div className='w-[250px] -mt-14 text-right'>
                       <div className='border-slate-400 pt-[2px]'>
                          <img alt="sign" className='ml-10' src={signatureImageSrc || signatureImageUrl} crossOrigin="anonymous" />
                          <h5 className='text-[14px] font-[700] -mt-5 text-[#072A67] tracking-wide'>AUTHORISED SIGNATURE</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='bg-[#072A67] text-white px-7 py-4 border-t-[5px] border-[#e5aa1f]'>
                  <div className='flex justify-between items-center'>
                    <div className='text-[12px]'><span className='font-[700] text-[#e5aa1f]'>Thank You!</span> for choosing My Academy Partner</div>
                    <div className='text-right text-[12px]' style={{ fontFamily: 'Dancing Script, cursive' }}>Together, we build a brighter future.</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

       

      </div>

      

    </div>
  )
}

export default OfflineCustomerCE